import { OAuthCredential } from 'firebase/auth';

/**
 * Module-level store for pending Google redirect credentials.
 * Used to pass account-linking error state from useAuth (app init)
 * to the Login component, since OAuthCredential is not Redux-serializable.
 */
let pendingCredential: OAuthCredential | null = null;
let pendingEmail: string | null = null;

export function setPendingRedirectCredential(
  cred: OAuthCredential | null,
  email: string | null,
) {
  pendingCredential = cred;
  pendingEmail = email;
}

export function consumePendingRedirectCredential(): {
  credential: OAuthCredential | null;
  email: string | null;
} {
  const result = { credential: pendingCredential, email: pendingEmail };
  pendingCredential = null;
  pendingEmail = null;
  return result;
}
